import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import styles from './CheckBoxInput.module.scss';

interface Props {
  label: string;
  options?: Array<any>;
  name: string;
  error?: any;
  register?: any;
  defaultValue?: string;
  OptionsISBlocked?: boolean;
  disabled?: boolean;
  value: boolean;
  onChange?:any
}

const CheckBoxInput: FunctionComponent<Props> = ({
  label,
  options,
  name,
  error,
  register,
  defaultValue,
  OptionsISBlocked,
  disabled,
  value,
  onChange
}) => {
  return (
    <div className={styles.CheckBoxInput}>
      <div
        className={`${styles.CheckBoxInput__labelRequired} ${
          OptionsISBlocked ? styles.LabelBlocked : ''
        }`}
      >
        {options?.length && (
          <FormLabel
            component="legend"
            data-testid="label-holder"
            className={disabled ? 'labelDisabled' : ''}
          >
            {label}
          </FormLabel>
        )}
        {error && (
          <p className={styles.Error} data-testid="error-holder">
            {error[name]?.message}
          </p>
        )}
      </div>
      <FormGroup
        data-testid="check-group-holder"
        className={`${disabled ? styles.InputDisabled : ''} ${
          OptionsISBlocked ? styles.OptionsISBlocked : ''
        }`}
      >
        {options?.length ? (
          options.map(({ label, value,Name }, i) => (
            <FormControlLabel
              key={i}
              data-testid={`options-holder`}
              disabled={disabled}
              control={
                <Checkbox
                  defaultChecked={
                    Array.isArray(defaultValue)
                      ? defaultValue.some((item) => item === value)
                      : defaultValue == value
                  }
                  data-testid={'check-holder'}
                  size="small"
                />
              }
              onChange={()=>onChange?.(Name)}
              label={label}
              value={value}
              {...register?.(name)}
            />
          ))
        ) : (
          <FormControlLabel
            data-testid={`options-holder`}
            disabled={disabled}
            control={
              <Checkbox
                defaultChecked={!!defaultValue === value}
                data-testid={'check-holder'}
                size="small"
              />
            }
            label={label}
            value={value}
            {...register?.(name)}
          />
        )}
      </FormGroup>
    </div>
  );
};

export default CheckBoxInput;
